/**
 * Whether the source (encoder) selector is disabled for an event.
 *
 * Two inputs, and both are needed:
 *
 * - `eventStatus` is server state. It is authoritative, but it lags the operator:
 *   it only moves when the start response or a websocket message says so.
 * - `startStopPending` is the local half -- a start or stop call in flight for
 *   this event. It covers the click, which is the gap `eventStatus` cannot see.
 *
 * The status list is an allowlist on purpose. A status neither list names --
 * one the backend adds later -- lands as disabled rather than silently
 * assignable, which is the failure this control had in the first place.
 */
export const ENCODER_SELECT_ENABLED_STATUS = ['new', 'available']

const encoderSelectDisabled = ({ eventStatus, startStopPending }) => {
  if (startStopPending) return true
  return !ENCODER_SELECT_ENABLED_STATUS.includes(eventStatus)
}

export default encoderSelectDisabled
